import React, { useMemo } from "react";

import { ERROR_MESSAGES } from "constants/errorMessages";
import { getPhoneConfigForIsd } from "constants/phoneConfig";
import { useCountriesMappings } from "store/backend/apiHooks";
import {
  getDefaultCountry,
  toIsdSelectOptions,
} from "utils/countryMappings";
import SingleSelect from "../Dropdown/SingleSelect";
import Textfield from "../Textfield/Textfield";

import styles from "./PhoneWithIsdInput.module.scss";

const PhoneWithIsdInput = ({
  phone,
  onPhoneChange,
  countryCode,
  onCountryCodeChange,
  phoneLabel = "Phone Number",
  disabled = false,
}) => {
  const {
    data: countries = [],
    isPending,
    isError,
    isFetching,
    refetch,
  } = useCountriesMappings();

  const isLoading = isPending || (isFetching && countries.length === 0);
  const menuItems = toIsdSelectOptions(countries);
  const resolvedCountryCode =
    countryCode || getDefaultCountry(countries)?.countryCode || "";
  const selectedCountry = useMemo(
    () =>
      countries.find((country) => country.countryCode === resolvedCountryCode),
    [countries, resolvedCountryCode]
  );
  const phoneConfig = getPhoneConfigForIsd(selectedCountry?.isdCode);

  let placeholder = "+91";
  if (isLoading) {
    placeholder = "...";
  } else if (isError) {
    placeholder = "—";
  } else if (!menuItems.length) {
    placeholder = "—";
  }

  return (
    <div className={styles.container}>
      <div className={styles.isdSelect}>
        <SingleSelect
          id="country-isd-select"
          name="countryCode"
          placeholder={placeholder}
          value={resolvedCountryCode}
          menuItems={menuItems}
          handleChange={(event) => onCountryCodeChange(event.target.value)}
          disabled={disabled || isLoading || !menuItems.length}
          errorMessage={
            isError ? ERROR_MESSAGES.COUNTRY_LOAD_RETRY : undefined
          }
        />
        {isError && (
          <button
            type="button"
            className={styles.retryButton}
            onClick={() => refetch()}
          >
            Retry
          </button>
        )}
      </div>
      <div className={styles.phoneField}>
        <Textfield
          label={phoneLabel}
          fullWidth
          margin="normal"
          value={phone}
          disabled={disabled}
          onChange={(event) => {
            const digitsOnly = (event.target.value || "")
              .replace(/\D/g, "")
              .slice(0, phoneConfig.maxLength);
            onPhoneChange(digitsOnly);
          }}
        />
      </div>
    </div>
  );
};

export default PhoneWithIsdInput;
